module.exports = __webpack_public_path__ + "static/media/01-Header-Image.fb716e4a.jpg";